/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnvironmentFilterType } from "./EnvironmentFilterType";
export const EnvironmentFilters = core.serialization.object({
    type: core.serialization.list(EnvironmentFilterType).optional(),
    excludeIds: core.serialization.property("exclude_ids", core.serialization.list(core.serialization.string()).optional()),
});
